const getCurrentLangCode = (pathname: string): string => {
  const pathSegments = pathname.split('/').filter((segment) => segment !== '');
  return pathSegments[0] || '';
};

export default getCurrentLangCode;
